import React from 'react';

const Cta = () => {
  return (
    <section className="cta" id="cta">
      <div className="container">
        <div className="reveal">
          <h2>Looking for <span className="highlight">Genuine</span> American Auto Parts?</h2>
          <p>
            Contact AUTO EXPERTS FZE today for reliable wholesale supply and
            worldwide export solutions.
          </p>
          <a href="#contact" className="btn-primary">
            <span className="btn-content">
              Request Wholesale Quote
              <span className="arrow">→</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cta;